import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { Observable } from "rxjs";
import { Courts, CourtsForRole, CourtStaff, CustomTtRoleDtlsDTO, ICourtUnitType, StaffAbsencesTypes } from "../models/court-staff-roles.model";
import { TAny } from "@app/lib/models/common.type";

@Injectable({
    providedIn: 'root'
})
export class CourtStaffRoleService extends BaseHttpService {
    
    constructor(
        http: HttpClient,
        appConfig: AppConfiguration,
    ) {
        super(http, appConfig);
    }
    getCourt() {
      return this.get<IResponse<Courts[]>>('court-staff/get/court-id.htm');
    }
    getRolesCourt() {
          return this.get<IResponse<CourtsForRole[]>>('court-staff/get/court-id.htm');
        }
    getRoles() {
      return this.get<IResponse<CustomTtRoleDtlsDTO[]>>('ttRole-dtls/fetch/roles-lov.htm');
    }
    
    getDivisions() {
      return this.get<IResponse<ICourtUnitType[]>>('court-unit-types/fetch.htm');
    }

    getstaffTypes() {
      return this.get<IResponse<CourtStaff[]>>('staff-types/get/lov.htm');
    }

    getAbsenceTypes() {
      return this.get<IResponse<StaffAbsencesTypes[]>>('absence-types/get.htm');
    }

    getstaffParties(courtId:number) {
        const queryParams={'courtId':courtId,'isCourtStaff':'Y'}
        return this.get<IResponse<CourtStaff[]>>('parties/get/lov.htm',{params:queryParams});
    }

    searchCourtStaffData(queryparams:any){
        return this.get<IResponse<CourtStaff[]>>('court-staff/get.htm',{params:queryparams});
    }

    saveModification(reqBody: any[], status: any[]) {
  return this.post<IResponse<TAny>, any[]>(
    'court-staff/upsert.htm',
    reqBody,
    { params: { transType: status } }
  );
}
}